import * as React from "react";

import AppThemePreview from "components/AppThemePreview";
import usePreview from "hooks/dialogs/appCustomizations/rightSide/usePreview";

const Preview = () => {
  const { mode, gradient, primary, logo } = usePreview();

  return (
    <div className="theme-builder-theme-preview">
      <AppThemePreview
        mode={mode}
        primary={primary}
        gradient={gradient}
        logo={logo}
        logoStyle={{
          position: "absolute",
          top: 12,
          left: 16,
          height: 36,
          width: 36,
        }}
        name="AppThemePreview"
        className="app-theme-preview-svg-dialog"
      />
    </div>
  );
};

export default Preview;
